import { useState } from 'react'
import { Sidebar } from './Sidebar'
import { MobileTopBar } from './MobileTopBar'
import { MobileDrawer } from './MobileDrawer'
import { AppRoutes } from './AppRoutes'
import { Footer } from './Footer'

interface AuthenticatedLayoutProps {
  avatarUrl: string | null
  displayName: string | null
  email: string | null
  isPro: boolean
  effectivePlan: string
  onLogout: () => void
  onStartProductTour: () => void
}

export function AuthenticatedLayout({
  avatarUrl,
  displayName,
  email,
  isPro,
  effectivePlan,
  onLogout,
  onStartProductTour,
}: AuthenticatedLayoutProps) {
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false)

  return (
    <div className="min-h-screen bg-app-page">
      {/* Desktop sidebar */}
      <Sidebar
        avatarUrl={avatarUrl}
        displayName={displayName}
        email={email}
        isPro={isPro}
        effectivePlan={effectivePlan}
        onLogout={onLogout}
      />

      {/* Mobile top bar */}
      <MobileTopBar
        avatarUrl={avatarUrl}
        onMenuOpen={() => setIsMobileDrawerOpen(true)}
      />

      {/* Mobile drawer */}
      <MobileDrawer
        isOpen={isMobileDrawerOpen}
        onClose={() => setIsMobileDrawerOpen(false)}
        avatarUrl={avatarUrl}
        displayName={displayName}
        email={email}
        isPro={isPro}
        effectivePlan={effectivePlan}
        onLogout={onLogout}
      />

      {/* Content area */}
      <main className="lg:ml-52 min-h-screen flex flex-col overflow-x-clip">
        <div className="flex-1 mx-auto max-w-[1400px] w-full px-3 sm:px-4 py-8 space-y-6">
          <AppRoutes onStartProductTour={onStartProductTour} />
        </div>
        <Footer />
      </main>
    </div>
  )
}
